var map = {
	"./Flag_of_Azerbaijan.svg": 2420,
	"./ONT-OIAA-logo.png": 2421,
	"./Partly-Cloudy.png": 939,
	"./americanFlag.png": 2422,
	"./feed.jpg": 2423,
	"./franceFlag.png": 2424,
	"./germanFlag.png": 2425,
	"./portugalFlag.png": 2426,
	"./russianFlag.png": 2427,
	"./spainFlag.png": 2428,
	"./todo-assignment.svg": 2429,
	"./user.svg": 961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2419;